/**
 * An empty base URL means same-origin. The Docker/nginx deployment serves the SPA and
 * reverse-proxies `/api` to the backend, so request paths must stay relative there;
 * Static Web App builds bake an absolute URL from `env/.env.<mode>` and call the API directly.
 */
const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? "").replace(
  /\/+$/,
  ""
);

export function apiUrl(path: string): string {
  return `${apiBaseUrl}${path}`;
}
